module.exports = __webpack_public_path__ + "img/image_section_1.54c9df0e.png";